import { SearchInput } from '@paypalcorp/pp-react'
import React, { useEffect, useRef } from 'react'
import { componentNames, fptiTypes } from '../../utils/analytics/fpti-constants'

// Hooks
import { useMessage } from '../../hooks/useMessage'
import { useHelper } from '../../hooks/useHelper'
import useTracking from '../../hooks/useTracking'

// styles
import './search-bar-v1.less'

function SearchBarV1() {
  const searchRef = useRef(null)
  const { getMessage } = useMessage()
  const { generateLinkWithCoBrand } = useHelper()
  const { trackActivity, trackClick } = useTracking()

  // component onmount
  useEffect(() => {
    //track fpti
    trackActivity({ name: componentNames.SEARCH_BAR, type: fptiTypes.SUCCESS })
  }, [])

  const onChangeHandler = (evt) => {
    if (evt.key === 'Enter') {
      // Track click event on searchbar
      trackClick({
        name: componentNames.SEARCH_BAR,
        type: fptiTypes.ON_CLICK,
        link: `search|full-search|enter|${searchRef.current.value}`,
        srch: searchRef.current.value,
      })

      // TODO: Sanitize search value
      location.href = generateLinkWithCoBrand(
        `/smarthelp/search?q=${searchRef.current.value}`,
      )
    }
  }

  const onClearHandler = () => {
    trackClick({
      name: componentNames.SEARCH_BAR,
      type: fptiTypes.ON_CLICK,
      link: 'search|clear-button|clicked',
    })
    searchRef.current.value = ''
  }

  return (
    <SearchInput
      ref={searchRef}
      onClear={() => onClearHandler()}
      label={getMessage('app.helpcenter.search')}
      name="helpCenterSearch"
      onKeyUp={onChangeHandler}
      className="hero-module-search"
      data-testid="hc-hero-module-search-input"
    />
  )
}

export default SearchBarV1
